// extracted by mini-css-extract-plugin
export default {"shift-month":"shift-month--LgRdm event-month--atv6w","shiftMonth":"shift-month--LgRdm event-month--atv6w"};